import { defaultTheme } from 'sletat-ui-components2/dist/theme';

const {theme} = defaultTheme;

export const styles = {
    container: {
        display: 'inline-block',
        padding: [2, 8],
        color: '#fff',
        fontSize: 13,
        fontWeight: 700,
        borderRadius: theme.borderRadiusVariables.btn,
    },
    orange: {
        backgroundColor: '#ff9207'
    },
    green: {
        backgroundColor: theme.colorVariables.iconPrimary,
    }
};

export type ComponentJSSClasses = typeof styles;
